import { useMutation } from '@tanstack/react-query';
import { ConvertToNewBusinessPostRequestBody, ConvertToNewBusinessPostResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';

export const useConvertRenewalToNewBusiness = () => {
  const client = useClient();

  const mutationFn = async (body: ConvertToNewBusinessPostRequestBody) =>
    client.post(`quote-copy/convert-to-new-business`, { json: body }).json<ConvertToNewBusinessPostResponse>();

  const result = useMutation({ mutationFn });
  return { ...result, convertRenewalToNewBusiness: result.mutateAsync };
};
